
export interface ShapeMappingItem {
    imageName: string; // The prefix to look for in the filename
    shapeId?: string;  // The target Shape ID
    shapeCode?: string; // OR the target Shape Code
    type: 'top' | 'front';
}

export const getShapeMapping = (): ShapeMappingItem[] => {
    try {
        const envString = process.env.REACT_APP_SHAPE_MAPPING;
        if (!envString) return [];

        const parsed = JSON.parse(envString);
        if (Array.isArray(parsed)) {
            return parsed as ShapeMappingItem[];
        }
        return [];
    } catch (error) {
        console.warn('Failed to parse REACT_APP_SHAPE_MAPPING', error);
        return [];
    }
};

export const resolveMappingForFile = (filename: string, mapping: ShapeMappingItem[]): ShapeMappingItem | undefined => {
    // Remove the file extension (e.g. "Coin_T.png" -> "Coin_T")
    const nameWithoutExt = filename.replace(/\.[^/.]+$/, "");

    // Strict case-insensitive match: The filename must EXACTLY match the imageName in the config
    return mapping.find(item => item.imageName.toLowerCase() === nameWithoutExt.toLowerCase());
};
